import { useEffect, useState } from 'react';

import ModalBase from '../../../ModalBase/ModalBase';

function ConfirmationModal({
  isOpen,
  toggle,
  deleteUserSubmittedQuestion,
  questionId,
  timestamp,
  setDeleteStatusMessage,
  deleteStatusMessage,
  handleChangeSelectedQuestion,
  handleResetQuestionToEdit,
  isUserQuestionsLoading,
}) {
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (deleteStatusMessage.message) {
      timeoutId = setTimeout(() => {
        setDeleteStatusMessage({ type: '', message: '' });
        if (isOpen) {
          toggle();
        }
      }, 3000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [deleteStatusMessage]);

  const handleDeleteQuestion = () => {
    setIsSubmitted(true);
    deleteUserSubmittedQuestion(questionId, timestamp);
    handleResetQuestionToEdit();
    handleChangeSelectedQuestion(null);
  };

  const handleCloseModal = () => {
    handleChangeSelectedQuestion(null);
    if (isOpen) {
      toggle();
    }
  };

  return (
    <ModalBase
      isOpen={isOpen}
      toggle={toggle}
      header={<>Delete Question</>}
      body={
        <>
          Do you want to delete this question?
          {deleteStatusMessage.type ? (
            <div
              className={`form__status-message--${deleteStatusMessage.type} confirmation__modal__message`}
            >
              {deleteStatusMessage.message}
            </div>
          ) : null}
        </>
      }
      footer={
        <>
          <button
            className="btn modal-base-btn secondary"
            onClick={handleCloseModal}
          >
            Cancel
          </button>
          <button
            data-test="delete-submit-question-confirmation-button"
            className="btn modal-base-btn primary"
            onClick={handleDeleteQuestion}
            disabled={isUserQuestionsLoading || isSubmitted}
          >
            Delete
          </button>
        </>
      }
    />
  );
}

export default ConfirmationModal;
